/**
 * @fileoverview Shared reactive state for the currently-viewed custom
 * dashboard.
 *
 * This is feature-local state that used to live on the global chrome store
 * (`useChromeStore.currentDashboardViewTitle` / `…Editable`). It is consumed
 * both from inside components (`DashboardView.vue`) and from plain JS (the
 * `dashboard-view` route meta in `src/router/routes/builder.js`), so the
 * state is held in module-level refs and shared as a singleton — reads from
 * either context observe the same values.
 *
 * `DashboardView.vue` sets the title/editability on load and resets them on
 * unmount; the route meta reads the title for breadcrumbs + favorite labels.
 */
import { readonly, ref } from 'vue';

const currentDashboardViewTitle = ref('');
const currentDashboardViewEditable = ref(false);

function setCurrentDashboardView({ title = '', editable = false } = {}) {
  currentDashboardViewTitle.value = title;
  currentDashboardViewEditable.value = Boolean(editable);
}

function clearCurrentDashboardView() {
  currentDashboardViewTitle.value = '';
  currentDashboardViewEditable.value = false;
}

export function useDashboardViewState() {
  return {
    currentDashboardViewTitle: readonly(currentDashboardViewTitle),
    currentDashboardViewEditable: readonly(currentDashboardViewEditable),
    setCurrentDashboardView,
    clearCurrentDashboardView,
  };
}
